export type NotificationType = "review" | "order" | "gig" | "system";
export type ActionType = 
  | "redirect_to_absolute_url" 
  | "redirect_to_relative_url" 
  | "redirect_to_chat_channel" 
  | "show_popup" 
  | "none";
export type ScopeType = "email" | "sms" | "none";
export type SeverityType = "urgent" | "warning" | "info" | "success";

export interface NotificationInterface {
  id: string;
  user: string; // User ID (buyer)
  type: NotificationType;
  severity: SeverityType;
  actionType: ActionType;
  title: string;
  message: string;
  isRead: boolean;
  scope: ScopeType[];
  metadata: Record<string, any>; // Generic metadata field
  createdAt?: Date;
  updatedAt?: Date;
}

export class Notification implements NotificationInterface {
  id: string;
  user: string;
  type: NotificationType;
  severity: SeverityType;
  actionType: ActionType;
  title: string;
  message: string;
  isRead: boolean;
  scope: ScopeType[];
  metadata: Record<string, any>;
  createdAt?: Date;
  updatedAt?: Date;

  constructor(jsonData: any) {
    this.id = jsonData._id;
    this.user = jsonData.user;
    this.type = jsonData.type;
    this.severity = jsonData.severity;
    this.actionType = jsonData.actionType;
    this.title = jsonData.title;
    this.message = jsonData.message;
    this.isRead = jsonData.isRead ?? false;
    this.scope = jsonData.scope || ["none"];
    this.metadata = jsonData.metadata || {};
    this.createdAt = jsonData.createdAt ? new Date(jsonData.createdAt) : undefined;
    this.updatedAt = jsonData.updatedAt ? new Date(jsonData.updatedAt) : undefined;
  }
}
